import { IsNotEmpty, IsUUID } from 'class-validator';

export class GetDocumentDto {
  @IsNotEmpty()
  @IsUUID()
  policyVersionId: string;

  @IsNotEmpty()
  @IsUUID()
  policyId: string;
}
